









import Vue from "vue";

import Header from "@/components/Landing/Header.vue";
import HeroSection from "@/components/Landing/HeroSection.vue";
import AboutSection from "@/components/Landing/AboutSection.vue";

export default Vue.extend({
	name: "Landing",
	metaInfo() {
		return {
			title: "RKAnik",
		};
	},
	components: {
		Header,
		HeroSection,
		AboutSection,
	},
});
